import { DataType } from "@/lib/types/module"

export interface DataTypeInfo {
  label: string
  /** OKLCH color for handles and edges */
  color: string
  /** Tailwind classes for badges and backgrounds */
  badgeClass: string
  /** Tailwind text color class */
  textClass: string
}

export const DATA_TYPE_INFO: Record<DataType, DataTypeInfo> = {
  [DataType.String]: {
    label: "String",
    color: "oklch(0.65 0.15 250)",
    badgeClass: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
    textClass: "text-blue-600 dark:text-blue-400",
  },
  [DataType.Image]: {
    label: "Image",
    color: "oklch(0.65 0.18 160)",
    badgeClass: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
    textClass: "text-emerald-600 dark:text-emerald-400",
  },
  [DataType.Video]: {
    label: "Video",
    color: "oklch(0.60 0.20 285)",
    badgeClass: "bg-violet-500/15 text-violet-600 dark:text-violet-400",
    textClass: "text-violet-600 dark:text-violet-400",
  },
  [DataType.Audio]: {
    label: "Audio",
    color: "oklch(0.70 0.15 80)",
    badgeClass: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
    textClass: "text-amber-600 dark:text-amber-400",
  },
  [DataType.Number]: {
    label: "Number",
    color: "oklch(0.55 0.05 250)",
    badgeClass: "bg-slate-500/15 text-slate-600 dark:text-slate-400",
    textClass: "text-slate-600 dark:text-slate-400",
  },
  [DataType.Boolean]: {
    label: "Boolean",
    color: "oklch(0.65 0.18 140)",
    badgeClass: "bg-green-500/15 text-green-600 dark:text-green-400",
    textClass: "text-green-600 dark:text-green-400",
  },
  [DataType.File]: {
    label: "File",
    color: "oklch(0.65 0.15 20)",
    badgeClass: "bg-rose-500/15 text-rose-600 dark:text-rose-400",
    textClass: "text-rose-600 dark:text-rose-400",
  },
  [DataType.Json]: {
    label: "JSON",
    color: "oklch(0.65 0.12 200)",
    badgeClass: "bg-cyan-500/15 text-cyan-600 dark:text-cyan-400",
    textClass: "text-cyan-600 dark:text-cyan-400",
  },
  [DataType.Trigger]: {
    label: "Trigger",
    color: "oklch(0.65 0.18 55)",
    badgeClass: "bg-orange-500/15 text-orange-600 dark:text-orange-400",
    textClass: "text-orange-600 dark:text-orange-400",
  },
  [DataType.Media]: {
    label: "Media",
    color: "oklch(0.60 0.22 320)",
    badgeClass: "bg-pink-500/15 text-pink-600 dark:text-pink-400",
    textClass: "text-pink-600 dark:text-pink-400",
  },
}

export function getDataTypeColor(type: DataType): string {
  return DATA_TYPE_INFO[type].color
}

export function getDataTypeLabel(type: DataType): string {
  return DATA_TYPE_INFO[type].label
}
